export default __webpack_public_path__ + "static/media/android.4722a10c.svg";